import { enUS } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";

type VehicleAvailabilityProps = {
  availability: string[];
  reservedDates: string[];
};

const VehicleAvailability: React.FC<VehicleAvailabilityProps> = ({
  availability,
  reservedDates,
}) => {
  // console.log(availability);
  // console.log(reservedDates);

  const [dates, setDates] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const [isAvailable, setIsAvailable] = useState(true);
  const [months, setMonths] = React.useState(1);

  // const [availabilityDates, setAvailabilityDates] = useState<Date[]>([]);

  function monthsBetweenDates(date1: Date, date2: Date) {
    let months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months + 1;
  }

  useEffect(() => {
    if (availability) {
      // const availableDates = availability.map((date) => {
      //   // console.log(date);
      //   return new Date(date);
      // });
      const availableDates = availability
        .map((date) => new Date(date))
        .sort((a, b) => a.getTime() - b.getTime());
      // if (availableDates.length > 0) {
      //   setAvailabilityDates(availableDates);
      // } else {
      //   return;
      // }

      if (!availableDates.length) return;

      if (new Date(availableDates[availableDates.length - 1]) < new Date()) {
        return setIsAvailable(false);
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // console.log(
      //   availabilityDates[0],
      //   availabilityDates[availabilityDates.length - 1]
      // );

      setDates({
        startDate:
          new Date(availableDates[0]) < today
            ? today
            : new Date(availableDates[0]),
        endDate: new Date(availableDates[availableDates.length - 1]),
        key: "selection",
      });

      setMonths(
        monthsBetweenDates(
          new Date(availableDates[0]) < today
            ? today
            : new Date(availableDates[0]),
          new Date(availableDates[availableDates.length - 1])
        )
      );

      // console.log("dates", dates);
    }
  }, [availability]);

  const handleRangeSelect = (item: any) => {
    // console.log("selection", item.selection);
    setDates({
      startDate: dates.startDate,
      endDate: dates.endDate,
      key: "selection",
    });

    // setDates(item.selection);
  };
  return (
    <div className="flex flex-col gap-7">
      <p className=" text-darkGreen font-Jakarta text-sm font-bold uppercase  ">
        AVAILABILITY
      </p>

      <div className="flex flex-col gap-3">
        {!isAvailable ? (
          <p className="text-red-500 text-sm font-bold text-center">
            Sorry, this vehicle is not available for lease at the moment.
          </p>
        ) : (
          <DateRange
            editableDateInputs={false}
            showDateDisplay={false}
            onChange={(item) => handleRangeSelect(item)}
            moveRangeOnFirstSelection={false}
            months={months}
            minDate={new Date()}
            disabledDates={reservedDates?.map((date) => new Date(date))}
            direction={window.innerWidth < 768 ? "vertical" : "horizontal"}
            color="#215759"
            locale={enUS}
            ranges={[dates]}
            preview={undefined}
            // minDate={new Date()}
            className="w-full pl-5 flex flex-col cursor-not-allowed gap-4 flex-wrap justify-center items-center overflow-x-scroll overflow-y-hidden"
          />
        )}
      </div>
    </div>
  );
};

export default VehicleAvailability;
